// Mismo formato/validación de RUT usado en Auth/CompleteProfile.tsx, Auth/SignUp.tsx
// y Account/AccountNurses.tsx — se reproduce aquí para no acoplar el módulo de
// Quotes a esos componentes.

export const formatRut = (value: string): string => {
  const clean = value.replace(/[^\dKk]/g, '').toUpperCase();
  if (clean.length <= 1) return clean;
  const dv = clean.slice(-1);
  const digits = clean.slice(0, -1);
  const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formatted}-${dv}`;
};

export const validateRut = (rut: string): boolean => {
  const clean = rut.replace(/[.\-\s]/g, '').toUpperCase();
  if (!/^\d{7,8}[0-9K]$/.test(clean)) return false;
  const digits = clean.slice(0, -1);
  const dv = clean.slice(-1);
  let sum = 0, factor = 2;
  for (let i = digits.length - 1; i >= 0; i--) {
    sum += parseInt(digits[i]) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const rem = 11 - (sum % 11);
  const expected = rem === 11 ? '0' : rem === 10 ? 'K' : String(rem);
  return dv === expected;
};
